import React from "react";
const TheATeamCom = (props) => {
    const width = document.body.clientWidth;
    return (
        <div className={`w-full h-48 sm:h-60 lg:h-80 xl:h-[400px] 2xl-wide:h-[450px] 3xl:h-[450px] overflow-hidden relative xs:rounded-3xl sm:rounded-[35px] lg:rounded-[50px] xl:rounded-[80px] cursor-pointer ${props.hoverlayout}`}
            style={{
                backgroundColor: props.bgcolor,
                width: width < 500
                    ? (width / 2) - 20 //"90%"
                    : width === 1024
                        ? (width / 4) - 20
                        : width === 768 ? (width / 4) - 20
                            : (width / 4) - 70
            }}
            onClick={props.onClick}>
            <img src={props.image} className="w-full h-full" alt={props.image} />
            <div className="absolute bottom-5 sm:bottom-7 lg:bottom-8 xs:left-4 sm:left-4 lg:left-5 xl:left-8 team-shadow">
                <h4 className="font-onestBold xs:text-xs sm:text-sm lg:text-xl text-secondary xs:leading-4">{props.title}</h4>
                <p className="font-onestMedium xs:text-xs sm:text-sm lg:text-base text-secondary xs:leading-3">{props.position}</p>
                <p className="font-onestRegular xs:text-[10px] sm:text-xs lg:text-sm text-secondary xs:leading-3">{props.location}</p>
            </div>
        </div>
    )
}
export default TheATeamCom;